import { InfoCircleOutlined } from '@ant-design/icons';
import { Popover, Row, Col } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import FormatNumber from '../../FormatNumber';
import styled from 'styled-components';
import _ from 'underscore';
import { SelectHelper } from '../../../DataEntry/utils/helper';
import { storeCommonStyles } from 'bukku/containers/Store/commonStyles';

const StyledPopover = styled(props => <Popover overlayClassName={props.className} {...props} />)`

    ${storeCommonStyles}

    .ant-popover-content {
        width: 170px;

        .ant-popover-inner {
            /* width: max-content; */
            width: 170px;
            background: var(--brand-color-teal-light);
            border-radius: 6px;
            
            .ant-popover-inner-content{
                padding: 6px 9px;
            }
        }
    }

    .ant-popover-arrow-content {
        background-color: var(--brand-color-teal-light);
    }

    .popover-list-item {
        padding: 0 5px;

        &.highlighted {
            font-weight: 900;
            color: white;
            background-color: var(--brand-color-teal);
            border-radius: 3px;

            .ant-col {
                text-shadow: 0 0 1px var(--brand-color-teal-light);

                .currency, .amount__base, .amount__cents, .suffix {
                    font-weight: 900;
                    text-shadow: 0 0 1px var(--brand-color-teal-light);
                    opacity: 1;
                }
            }
        }
    }
`;

/**
 * OPTIONAL PROPS
 * priceLevels: required when no redux's product.
 *              - If both (priceLevels and product) present, will take priceLevels
 * uomLabel:
 * currentPriceLevel:
 */
class PriceLevelPopover extends Component {
    getPopoverContent = () => {
        const {
            // parent
            currentPriceLevel,
            // redux
            store,
        } = this.props;
        return (
            <ul>
                {this.getPriceLevels().map((p, index) => {
                    let className = 'popover-list-item';
                    if (currentPriceLevel && _.isEqual(p, currentPriceLevel))
                        className += ' highlighted';
                    return (
                        // eslint-disable-next-line react/no-array-index-key
                        <li key={index} className={className}>
                            <Row className="center-vertically">
                                <Col flex="1 0 30px" className="ellipsis-div">
                                    {p.min_qty}
                                    +&nbsp;
                                </Col>
                                <Col flex="0 1 auto">
                                    <FormatNumber
                                        currency={store.currencySymbol}
                                        amount={p.unit_price}
                                        suffix={`/ ${this.getUOM()}`}
                                    />
                                </Col>
                            </Row>
                        </li>
                    );
                })}
            </ul>
        );
    };

    getPriceLevels = () => {
        const {
            // redux
            product,
            // parent
            priceLevels,
        } = this.props;

        return priceLevels || product.salePrice;
    };

    getUOM = () => {
        const {
            // redux
            product,
            // parent
            uomLabel,
        } = this.props;

        if (uomLabel)
            return uomLabel;
        if (product)
            return product.unitLabel;
        if (!uomLabel && !product?.unitLabel)
            return undefined;
        return null;
    };

    render() {
        const {
            // parent
            popupContainerId,
            // redux
        } = this.props;

        if (!this.getPriceLevels() || this.getPriceLevels().length === 1)
            return null;

        return (
            <StyledPopover
                className="popover__price-level"
                content={this.getPopoverContent()}
                getPopupContainer={SelectHelper.getPopupContainer(popupContainerId || 'parentElement')}
            >
                <InfoCircleOutlined />
            </StyledPopover>
        );
    }
}

export default connect(state => ({
    store: state.Store.store,
    product: state.Store.product,

}), {

})(PriceLevelPopover);
